import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { en } from "./locales/en";
import { vi } from "./locales/vi";
import { zhHans } from "./locales/zh-Hans";

export const LOCALES = [
  { code: "en", label: "EN", compactLabel: "EN", name: "English" },
  { code: "vi", label: "VI", compactLabel: "VI", name: "Tiếng Việt" },
  { code: "zh-Hans", label: "中", compactLabel: "中文", name: "简体中文" },
] as const;

const STORAGE_KEY = "hb.locale";

/**
 * Tiếng Hoa của giao diện là giản thể (zh-Hans) từ 21/09/2026, trước đó là phồn thể
 * (zh-Hant). Trình duyệt đã chọn tiếng Hoa vẫn còn lưu "zh-Hant": không đổi thì
 * i18next không có bộ dịch nào cho mã đó, lặng lẽ hiện tiếng Anh, và bộ chọn ngôn ngữ
 * không sáng ô nào.
 */
export function savedLocale(value: string | null): string | null {
  return value?.startsWith("zh") ? "zh-Hans" : value;
}

const saved = savedLocale(
  typeof localStorage !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null,
);

void i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    vi: { translation: vi },
    "zh-Hans": { translation: zhHans },
  },
  lng: saved ?? "en",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

i18n.on("languageChanged", (lng) => {
  try {
    localStorage.setItem(STORAGE_KEY, lng);
    document.documentElement.lang = lng;
  } catch {
    /* ignore */
  }
});

if (typeof document !== "undefined") {
  document.documentElement.lang = saved ?? "en";
}

export default i18n;
